import { t } from "../i18n";

export const TABLE_SECTIONS = [
  {
    title: t("compareGeneralData", "DANE OGÓLNE"),
    rows: [
      { label: t("compareApplications", "APLIKACJE"), key: "applications" },
      { label: t("compareMaterial", "MATERIAŁ"), key: "materials" },
      { label: t("compareRecycled", "ZAWARTOŚĆ RECYKLINGU"), key: "recycled" },
      { label: t("compareCertificates", "CERTYFIKATY"), key: "certificates", type: "certificates" },
    ],
  },
  {
    title: t("compareTechnicalData", "DANE TECHNICZNE"),
    rows: [
      { label: t("compareMfi", "MFI"), key: "mfi" },
      { label: t("compareDensity", "GĘSTOŚĆ"), key: "density" },
      { label: t("compareFiltration", "FILTRACJA"), key: "filtration" },
      { label: t("compareAsh", "POPIÓŁ"), key: "ash" },
      { label: t("compareThickness", "GRUBOŚĆ"), key: "thickness" },
    ],
  },
];